export default "__VITE_ASSET__C8C5Zu60__"